// Copyright © 2021 Move Closer
export * from './can-be-disabled.contracts';
export * from './can-be-disabled';
